import React from "react";
import FormInput from "Common/Custom/FormInput";
import FormSubmitButton from "Common/Custom/FormSubmitButton";
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";

// Uses `fields` prop from parent — does not re-import JSON directly
const AddBedForm = ({
  fields = [],
  values,
  errors,
  handleChange,
  handleSubmit,
  loading,
  title = "Add Bed",
}) => {
  return (
    <PageBody
      onSubmit={handleSubmit}
      headerchildren={<HeadingOne>{title}</HeadingOne>}
    >
      {fields.map((field) => (
        <FormInput
          key={field.name}
          field={field}
          value={values[field.name]}
          handleChange={handleChange}
          error={errors[field.name]}
        />
      ))}

      <FormSubmitButton
        label="Add Bed"
        loading={loading}
        colSize="col-12"
        align="end"
      />
    </PageBody>
  );
};

export default AddBedForm;
